<template>
  <el-dialog class="menu-dialog" v-bind="$attrs" v-on="$listeners">
    <div class="el-dialog-body-child">
      <div class="top-box">
        <div class="btn-box flex-c-s">
          <el-button type="primary" size="small" @click="foldOrCollapse">{{
            !isExpand ? "全部展开" : "全部折叠"
          }}</el-button>
          <el-button type="danger" size="small" @click="selectAllOrReversal">{{
            !isSelectAll ? "全部选中" : "全部不选"
          }}</el-button>
          <el-button type="warning" size="small" @click="toggleSelect"
            >全部反选</el-button
          >
          <el-button plain size="small" @click="reset">重 置</el-button>
          <el-input
            class="filter-input flex-grow"
            size="small"
            placeholder="输入关键字进行过滤"
            v-model="filterText"
          ></el-input>
        </div>
      </div>

      <xiaobu-tree
        ref="tree"
        class="permission-list"
        :filter-node-method="filterNode"
        :check-strictly="true"
        show-checkbox
        node-key="wareHouseId"
        @expandChange="expandChange"
        @check-change="checkChange"
        :settings="defaultProps"
        :default-expand-all="isExpand"
        :data="wareHouseData"
      ></xiaobu-tree>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">关 闭</el-button>
        <el-button type="primary" @click="save">保 存</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import XiaobuTree from "./xiaobu-tree/index.vue"
import { userApi, wareHouseApi } from "@/api"
export default {
  name: "SelectWareHouse",
  components: {
    XiaobuTree
  },
  props: {
    userId: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      filterText: "", // 列表过滤条件
      wareHouseData: [],
      defaultProps: {
        children: "children",
        label: "wareHouseName",
        disabled: (data) => {
          return data.children && data.children.length > 0 
        }
      },
      isExpand: true, // 是否展开
      isSelectAll: false, // 是否选中所有
      currentWareHouseIds: [], // 记录最开始的值
      wareHouseIds: [] // 选中的id
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree && this.$refs.tree.getTree().filter(val)
    },
    userId(val) {
      if (val) {
        userApi.getWareHouseIdsByUserId({ userId: val }).then((data) => {
          this.currentWareHouseIds = data.map((item) => item.wareHouseId)
          this.wareHouseIds = data.map((item) => item.wareHouseId)
          this.$nextTick(() => {
            this.$refs.tree && this.$refs.tree.getTree().setCheckedKeys(this.wareHouseIds)
          })
        })
      }
    }
  },
  async created() {
    await this.getWareHouseTree()
  },
  methods: {
    clear() { 
      this.$nextTick(() => {
        this.$refs.tree && this.$refs.tree.getTree().setCheckedKeys([])
      })
    },
    // 渲染最初始值
    reset() {
      this.$nextTick(() => {
        this.$refs.tree && this.$refs.tree.getTree().setCheckedKeys(this.currentWareHouseIds)
      })
    },
    // 过滤树形数据
    filterNode(value, data) {
      if (!value) {
        return true
      }
      return data.wareHouseName.indexOf(value) !== -1
    },
    // 保存
    async save() {

      const params = {
        userId: this.userId,
        wareHouseIds: this.wareHouseIds
      }
      userApi
        .setWareHouseIdsByUserId(params)
        .then((data) => {
          this.$modal.msgSuccess(data.msg)
          this.filterText = ""
          this.$emit("close")
        })
    },
    // 获取列表
    async getWareHouseTree() {
      return wareHouseApi.getWareHouseTree().then((data) => {
        this.wareHouseData = data
      })
    },
    /**
     * @description: 权限选项展开或者折叠时事件
     * @param {*}
     * @return {*}
     * @author: syx
     */
    expandChange() {
      setTimeout(() => {
        if (this.isExpand) {
          const isFoldAllFirstLevel = this.$refs.tree.judgeFoldAllFirstLevel() //是否折叠所有一级树
          if (isFoldAllFirstLevel) {
            this.isExpand = false
          }
        } else {
          const isExpandAllFirstLevel =
            this.$refs.tree.judgeExpandAllFirstLevel() //是否展开所有一级树
          if (isExpandAllFirstLevel) {
            this.isExpand = true
          }
        }
      }, 100)
    },
    /**
     * @description: 当前节点选中状态变化时
     * @param {*}
     * @return {*}
     * @author: syx
     */
    checkChange() {
      this.wareHouseIds = this.$refs.tree.getTree().getCheckedKeys()
      setTimeout(() => {
        //如果是全选状态，即文字显示 全部不选  则判断是否已经全部未选中
        if (this.isSelectAll) {
          const isUnSelectAll = this.$refs.tree.judgeUnSelectAll()
          if (isUnSelectAll) {
            this.isSelectAll = false
          }
        } else {
          //如果是未全选状态，即文字显示 全部选中  则判断是否已经全部选中
          const isSelectAll = this.$refs.tree.judgeSelectAll()
          if (isSelectAll) {
            this.isSelectAll = true
          }
        }
      }, 300)
    },
    /**
     * @description: 点击展开或收起
     * @param {*}
     * @return {*}
     * @author: syx
     */
    foldOrCollapse() {
      if (this.isExpand) {
        this.$refs.tree.foldAll()
        this.isExpand = false
      } else {
        this.$refs.tree.expandAll()
        this.isExpand = true
      }
    },
    /**
     * @description: 全选或者全不选
     * @param {*}
     * @return {*}
     * @author: syx
     */
    selectAllOrReversal() {
      if (this.isSelectAll) {
        this.$refs.tree.unSelectAll()
        this.isSelectAll = false
      } else {
        this.$refs.tree.selectAll()
        this.isSelectAll = true
      }
    },
    /**
     * @description: 全部反选
     * @param {*}
     * @return {*}
     * @author: syx
     */
    toggleSelect() {
      this.$refs.tree.toggleSelectAll()
    }
  }
}
</script>
<style lang="scss" scoped></style>
